import React from 'react';
import { motion } from 'framer-motion';
import WhatsAppConnect from '../components/whatsappConnect';
import InquiryButton from '../components/InquiryButton';

// Reusable Navbar Component
const PageNavbar = () => {
  return (
    <nav className="fixed top-0 w-full bg-white shadow-md z-50 flex items-center justify-between px-6 h-24 overflow-hidden">
      <img
        src="/Hydrocawach_logo.png"
        alt="HydroCawach Logo"
        className="h-36 w-auto object-contain"
      />
      <h1 className="absolute left-1/2 transform -translate-x-1/2 text-blue-600 text-lg md:text-2xl font-bold text-center">
        Cosmetics & Personal Care
      </h1>
    </nav>
  );
};

// --- Data for this page ---
const cosmeticApplications = [
  { title: 'Mixing & Homogenization', description: 'Achieves nano-scale uniformity for creams, gels, and lotions.' },
  { title: 'Solubilization', description: 'Enhances dissolution of actives, fragrances, and colorants.' },
  { title: 'Hydration of Polymers', description: 'Rapid activation of thickeners, gums, and stabilizers.' },
  { title: 'Emulsion Formation', description: 'Produces stable O/W and W/O emulsions with fine droplet size.' },
  { title: 'Functionalization', description: 'Improves bioavailability and performance of cosmetic ingredients.' },
];

const cosmeticAdvantages = [
  { icon: '⚡', title: 'High Efficiency', description: 'Reduces processing time and energy use.' },
  { icon: '💧', title: 'Superior Product Quality', description: 'Uniform texture, gloss, and stability.' },
  { icon: '🌱', title: 'Eco-Friendly', description: 'Minimizes chemical emulsifiers and thermal load.' },
  { icon: '🔄', title: 'Continuous & Scalable', description: 'Ideal for both lab-scale and production setups.' },
  { icon: '⚙️', title: 'Low Maintenance', description: 'Compact, plug-and-play operation.' },
];
// --- End of Data ---


const CosmeticsTechnology = () => {
  return (
    <div className="bg-white text-gray-800 min-h-screen relative overflow-x-hidden">
      <PageNavbar />

      <div className="pt-32 px-4 max-w-5xl mx-auto">

        {/* Introduction Section */}
        <motion.section
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Hydrocawach Cavitation Systems for Cosmetics
          </h2>

          <p className="text-lg text-gray-700 leading-relaxed mb-4 text-center max-w-3xl mx-auto">
            Hydrocawach offers advanced cavitation
            reactors engineered for cosmetic formulation processing — delivering
            precise control over mixing, particle size, and emulsion stability.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed text-center max-w-3xl mx-auto">
            Our systems enable consistent product quality, enhanced functionality, and
            sustainable manufacturing, meeting the stringent standards of personal
            care and pharmaceutical industries.
          </p>
        </motion.section>

        {/* Grid for Applications and Advantages */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">

          {/* Applications Column */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="bg-pink-50 border border-pink-200 rounded-lg p-6 shadow-lg"
          >
            <h3 className="text-2xl font-bold text-pink-700 mb-6">Applications</h3>
            <ul className="space-y-4">
              {cosmeticApplications.map((app) => (
                <li key={app.title} className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-pink-500 flex-shrink-0 mr-3 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div>
                    <span className="font-semibold text-gray-800">{app.title}:</span>
                    <p className="text-gray-700">{app.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Advantages Column */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            Boolean className="bg-blue-50 border border-blue-200 rounded-lg p-6 shadow-lg"
          >
            <h3 className="text-2xl font-bold text-blue-700 mb-6">Advantages</h3>
            <ul className="space-y-4">
              {cosmeticAdvantages.map((adv) => (
                <li key={adv.title} className="flex items-start">
                  <span className="text-3xl flex-shrink-0 mr-3 -mt-1">{adv.icon}</span>
                  <div>
                    <span className="font-semibold text-gray-800">{adv.title}:</span>
                    <p className="text-gray-700">{adv.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

      </div>

      {/* Floating Components */}
      <WhatsAppConnect />

    </div>
  );
};

export default CosmeticsTechnology;